import { ChangeEvent, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
  closeSuccessModal,
  confirmSignUpInvestor,
  userSelector,
  signInInvestor,
  incrementalId,
  setLoadingState,
  trullyFirstStep
} from 'src/store/User/user.slice';
import addUserToGroup from 'src/functions/addUserToGroup';
import getIp from 'src/functions/getIp';
import getCurrentDate from 'src/functions/getCurrentDate';
import { useGeolocation } from 'src/hooks/useGeolocation';
import { ModalSignupSuccess } from './signupSuccess.styles';
import { RootState } from 'src/store/store';
import { useAppThunkDispatch } from 'src/store/store';

type ModalSignupSuccessProps = {
  userId: string;
  email: string;
  password: string;
  typeOfPerson: string;
  showSuccessModal: boolean;
};

const SignupSuccess: React.FC<ModalSignupSuccessProps> = () => {
  const showSuccessModal = useSelector((state: RootState) => state.user.showSuccessModal);
  const email = useSelector((state: RootState) => state.user.email);
  const typeOfPerson = useSelector((state: RootState) => state.user.typeOfPerson);
  const [disabled, setDisabled] = useState(true);
  const [verifierCode, setVerifierCode] = useState('');

  //Geolocation
  const currentUser = useSelector(userSelector);
  const { getUserLocation, error: errorGeolocation } = useGeolocation();

  const navigate = useNavigate();
  const dispatch = useAppThunkDispatch();
  const { errorType } = useSelector((state: RootState) => state.user);

  const handleCode = (e: ChangeEvent<HTMLInputElement>) => {
    const code = e.target.value;
    setVerifierCode(code);
    const isValidCode = code.length >= 6 && /^\d+$/.test(code);
    setDisabled(!isValidCode);
  };

  const handleClick = () => {
    verifyAuthCode();
  };

  const errorText = () => {
    switch (errorType) {
      case 'CodeMismatchException':
        return 'Código incorrecto, vuelve a ingresarlo';
      case 'User is already confirmed.':
        return (
          <>
            Ya has verificado tu correo anteriormente
            <Link to="/iniciar-sesion">Iniciar sesión.</Link>
          </>
        );
      case 'Confirmation code cannot be empty':
        return 'Ingresa de nuevo el código de confirmación';
    }
  };

  const verifyAuthCode = async () => {
    setDisabled(true);
    const userGeolocation = await getUserLocation().catch((err) => {
      console.error('Error getting geolocation:', err);
      return null;
    });
    if (!userGeolocation) {
      dispatch(setLoadingState(false));
      return alert('ERRORR');
    }
    const [ip, date] = await Promise.all([getIp(), getCurrentDate()]);
    dispatch(setLoadingState(false));

    const user = {
      id: currentUser.id,
      typeOfPerson,
      email: currentUser.email,
      password: currentUser.password,
      ip,
      geolocation: userGeolocation,
      date,
      code: verifierCode,
      showSuccessModal
    };
    const trully = {
      id: currentUser.id,
      typeOfUser: 'investor'
    };
    try {
      await dispatch(confirmSignUpInvestor({ user }));
      await addUserToGroup(user.email, 'investor');
      const trullyResponse = await dispatch(trullyFirstStep(trully));
      if (trullyResponse.payload === 'No Threat') {
        await dispatch(signInInvestor({ email: user.email, password: user.password }));
        await dispatch(incrementalId({ id: user.id, typeOfUser: 'investor' }));
      } else {
        navigate('/validation-page');
        return;
      }
    } catch (error) {
      console.error('Error confirming sign up', error);
    }
    if (user.typeOfPerson === 'FISICA') {
      navigate('/inversionista/onboarding-data-f');
    } else {
      navigate('/inversionista/onboarding-data-m');
    }
  };

  return (
    <>
      {showSuccessModal && (
        <ModalSignupSuccess>
          <div>
            <h2>
              ¡Has creado tu cuenta en <span>FINSPHERA!</span>
            </h2>
            <p>¡Estás a punto de pertenecer a FinSphera!</p>
            <p>
              Enviamos un correo a <span>{email}</span> para confirmar tu cuenta; Ingresa el código.
            </p>
            <input name="code" type="text" onChange={handleCode} />
            <button onClick={handleClick} disabled={disabled}>
              Enviar
            </button>
            {errorType && <p>{errorText()}</p>}
          </div>
        </ModalSignupSuccess>
      )}
    </>
  );
};

export default SignupSuccess;
